<igo-directions
  [contextUri]="currentContextUri"
  [debounce]="debounceTime"
  [stopsStore]="stopsStore"
  [stopsFeatureStore]="stopsFeatureStore"
  [stepsFeatureStore]="stepFeatureStore"
  [routesFeatureStore]="routesFeatureStore"
  [zoomToActiveRoute]="zoomToActiveRoute"
  [authenticated$]="authenticated$"
/>
